import { Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled(Typography)(() => ({
  fontSize: '32px',
  margin: '20px 0',
  fontWeight: 600,
}));

export const ContainerGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  minHeight: '720px',
  height: '100vh',
  justifyContent: 'center',
  background: theme.palette.primary.main,
}));

export const LogoGrid = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const LogoImg = styled(Box)(({ theme }) => ({
  zIndex: 5,
  img: {
    [theme.breakpoints.down('lg')]: {
      width: 400,
    },
    [theme.breakpoints.up('lg')]: {
      width: 547,
    },
  },
}));

export const LoginGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.common.white,
  borderTopLeftRadius: '30px',
  borderBottomLeftRadius: '30px',
}));

export const InputBox = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '60px',
}));

export const StageBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  [theme.breakpoints.down('xl')]: {
    gap: '8px',
  },
}));
